module.exports = __webpack_public_path__ + "static/media/FETPlacementUpload_Template.3ac8c32b.xlsx";